(function(Drupal) {
  'use strict';

  Drupal.behaviors.video_modal = {
    attach: function(context, settings) {
      const videoMaxWidth = 700;
      const videoModalTriggers = document.querySelectorAll('.remote-video-button');

      const sizeVideoFrame = (iframe, height, width) => {
        let w = Math.min(videoMaxWidth, window.innerWidth);
        let h = height * (w / width);
        let winHeight = window.innerHeight;

        if (h > (winHeight - 64)) {
          h = winHeight - 64;
          w = width * (h / height);
        }
      };

      const focusTrap = (modal) => {
        const focusableItems = modal.querySelectorAll('button, input, select, textarea, a[href]');
        const firstFocusable = focusableItems[0];
        const lastFocusable = focusableItems[focusableItems.length - 1];
        firstFocusable.focus();

        lastFocusable.addEventListener('focus', (event) => {
          event.preventDefault();
          firstFocusable.focus();
        });

        modal.addEventListener('keydown', (e) => {
          if (e.key === 'Tab') {
            if (e.shiftKey) {
              if (document.activeElement === firstFocusable) {
                e.preventDefault();
                lastFocusable.focus();
              }
            }
            else if (document.activeElement === lastFocusable) {
              e.preventDefault();
              firstFocusable.focus();
            }
          }
        });
      };

      const buttonLoadVideo = (btn) => {
        const src = btn.getAttribute('data-src');
        const title = btn.getAttribute('data-title');
        const width = btn.getAttribute('width');
        const height = btn.getAttribute('height');
        const toOverlay = btn.getAttribute('data-video-overlay') === 'true';

        const iframe = document.createElement('iframe');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('height', height);
        iframe.setAttribute('width', width);
        iframe.setAttribute('allow', 'autoplay');
        const symbol = src.includes('?') ? '&' : '?';
        iframe.setAttribute('src', `${src}${symbol}autoplay=1`);
        iframe.setAttribute('title', title);

        if (toOverlay) {
          const overlay = document.createElement('div');
          overlay.classList.add('video-player-overlay');

          const videoDismiss = document.createElement('div');
          videoDismiss.classList.add('video-dismiss');

          const videoWrap = document.createElement('div');
          videoWrap.classList.add('video-wrap');
          videoWrap.id = 'video-modal';

          const closeVideo = document.createElement('button');
          closeVideo.classList.add('close-video');
          closeVideo.innerHTML = '<span class="sr-only">Close</span><i class="fa-solid fa-xmark"></i>';

          const focusEnd = document.createElement('a');
          focusEnd.href = '#';

          videoDismiss.addEventListener('click', () => {
            overlay.remove();
            document.getElementById('main-canvas').classList.remove('no-scroll');
          });

          closeVideo.addEventListener('click', () => {
            overlay.remove();
            document.getElementById('main-canvas').classList.remove('no-scroll');
          });

          videoWrap.appendChild(closeVideo);
          videoWrap.appendChild(iframe);
          videoWrap.appendChild(focusEnd);
          overlay.appendChild(videoDismiss);
          overlay.appendChild(videoWrap);

          if (window.innerWidth < videoMaxWidth) {
            videoWrap.classList.add('full-width');
          }

          document.getElementById('main-canvas').appendChild(overlay);
          document.getElementById('main-canvas').classList.add('no-scroll');
          sizeVideoFrame(iframe, height, width);
          focusTrap(videoWrap);
        }
        else {
          btn.parentNode.replaceChild(iframe, btn);
        }
      };

      videoModalTriggers.forEach((trigger) => {
        if (!trigger.dataset.openModal) {
          trigger.dataset.openModal = true;
          trigger.addEventListener('click', () => {
            buttonLoadVideo(trigger);
          });
        }
      });
    }
  };
})(Drupal);
